import React from 'react';
import IconBase from './shared/icon-base';
import { jsx as ___EmotionJSX } from "@emotion/core";
export default function GridIcon(props) {
  return ___EmotionJSX(IconBase, props, ___EmotionJSX("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 11H8C9.6543 11 11 9.6543 11 8V5C11 3.3457 9.6543 2 8 2H5C3.3457 2 2 3.3457 2 5V8C2 9.6543 3.3457 11 5 11ZM9 5C9 4.44824 8.55176 4 8 4H5C4.44824 4 4 4.44824 4 5V8C4 8.55176 4.44824 9 5 9H8C8.55176 9 9 8.55176 9 8V5Z",
    fill: "currentColor"
  }), ___EmotionJSX("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 11H19C20.6543 11 22 9.6543 22 8V5C22 3.3457 20.6543 2 19 2H16C14.3457 2 13 3.3457 13 5V8C13 9.6543 14.3457 11 16 11ZM20 5C20 4.44824 19.5518 4 19 4H16C15.4482 4 15 4.44824 15 5V8C15 8.55176 15.4482 9 16 9H19C19.5518 9 20 8.55176 20 8V5Z",
    fill: "currentColor"
  }), ___EmotionJSX("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 22H19C20.6543 22 22 20.6543 22 19V16C22 14.3457 20.6543 13 19 13H16C14.3457 13 13 14.3457 13 16V19C13 20.6543 14.3457 22 16 22ZM20 16C20 15.4482 19.5518 15 19 15H16C15.4482 15 15 15.4482 15 16V19C15 19.5518 15.4482 20 16 20H19C19.5518 20 20 19.5518 20 19V16Z",
    fill: "currentColor"
  }), ___EmotionJSX("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 22H8C9.6543 22 11 20.6543 11 19V16C11 14.3457 9.6543 13 8 13H5C3.3457 13 2 14.3457 2 16V19C2 20.6543 3.3457 22 5 22ZM9 16C9 15.4482 8.55176 15 8 15H5C4.44824 15 4 15.4482 4 16V19C4 19.5518 4.44824 20 5 20H8C8.55176 20 9 19.5518 9 19V16Z",
    fill: "currentColor"
  }));
}